module.exports = __webpack_public_path__ + "static/media/unnamed.f86595db.jpg";